import React, { useRef } from 'react';
import styled from 'styled-components';
import iconEdit from './icon-edit.svg';
import CustomerDetailModal, { CustomerDetailModalRef } from '../CustomerDetailModal';
import { ICustomerUI } from 'types/customer';
import { IBodyUpdateCustomerDetail } from 'services/types/apt';
import { loadingPageSignal } from 'components/LoadingPage';
import { AxiosResponse } from 'axios';
import { IAddNewCustomerResData } from 'services/types/response';
import apis from 'services/apis';
import { useAppDispatch } from 'store/hooks';
import shopActions from 'services/actions/shop';
type Props = {
  customerId?: number;
  visible?: boolean;
  onSelect: (data: ICustomerUI) => void;
  renderButton?: (props: { onClick: () => void, iconSrc?: any }) => React.ReactNode;
};
const ButtonEditCustomer = ({ customerId, visible, onSelect, renderButton }: Props) => {
  const dispatch = useAppDispatch();
  const modalRef = useRef<CustomerDetailModalRef>(null);
  const handleEditCustomer = async () => {
    const data = await modalRef.current?.open(customerId);
    if (!data) return;
    const body: IBodyUpdateCustomerDetail = {
      ...data,
      phone: data.phone?.replace(/[^0-9]/g, ''),
      fullName: [data.firstName || '', data.lastName || '']?.filter(Boolean).join(' '),
    };
    loadingPageSignal.value = true;
    try {
      const res: AxiosResponse<{ payload: IAddNewCustomerResData | null }> = await apis.updateCustomerDetail(customerId?.toString() || '', body);
      const data = res?.data?.payload;

      if (data) {
        const newCus: ICustomerUI = {
          id: data.customerId?.toString(),
          name: data.customerName,
          phone: data.customerPhone,
        };

        dispatch(shopActions.afterUpdateCustomer(newCus));

        onSelect(newCus);
      }
    } catch (error) { } finally {
      loadingPageSignal.value = false;
    }
  };
  return <>
    {renderButton ? renderButton({ onClick: handleEditCustomer, iconSrc: iconEdit }) : (
      <ButtonEditCustomerStyled disabled={!visible} style={{ opacity: visible ? 1 : 0 }} type='button' onClick={handleEditCustomer}>
        <img src={iconEdit} alt="IconEdit" className='icon-edit' />
        <span>Edit</span>
      </ButtonEditCustomerStyled>
    )}
    <CustomerDetailModal ref={modalRef} />
  </>;
};

export default ButtonEditCustomer;

const ButtonEditCustomerStyled = styled.button`
  display: flex;
  align-items: center;
  justify-content: end;
  height: 50px;
  width: 100px;
  gap: 8px;
  text-align: right;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  &:active {
    background: #F5F5F5;
  }
  span {
    color: #148CF1;
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px; /* 166.667% */
    text-transform: capitalize;
  }
  .icon-edit {
    width: 28px;
    height: 28px;
  }
`;
